import {RoleEnum} from '../enums/role-enum';
import {UserEntity} from './user-entity';
import {PermissionEnum} from '../enums/permission-enum';
import {DatePatternEnum} from '../enums/date-pattern.enum';
import {UserNotificationView} from './user-notification-view';
import {NumberSeparatorEnum} from '../enums/number-separator.enum';
import {ReCaptcha} from './re-captcha';

export interface UserCreate {
  Email: string;
  First_Name: string;
  Last_Name: string;
  Phone: string;
  Mobile: string;
  Role: RoleEnum;
  Entities?: UserEntity[];
}

export interface UserView {
  Id: string;
  Email: string;
  First_Name: string;
  Last_Name: string;
  Phone: string;
  Mobile: string;
  Role: RoleEnum;
  Entities?: UserEntity[];
  Preferred_Language: string;
  Preferred_Currency: string;
  Summary_Email_Enabled: boolean;
  Blocked: boolean;
  GDPR_Accepted: boolean;
  PermissionSet: PermissionEnum[];
  Alert_Ready_Order: boolean;
  Date_Pattern: DatePatternEnum;
  Notifications: UserNotificationView[];
  Thousand_Separator: NumberSeparatorEnum;
  Decimal_Separator: NumberSeparatorEnum;
  Create_Date?: string;
  Registered?: string;
  Last_Login?: string;
  Attached?: boolean;
  Attached_On?: string;
}

export interface UserEdit {
  Email: string;
  First_Name: string;
  Last_Name: string;
  Phone: string;
  Mobile: string;
  Role: RoleEnum;
  Entities?: UserEntity[];
}

export interface UserEditSelf {
  Email: string;
  First_Name: string;
  Last_Name: string;
  Phone: string;
  Mobile: string;
  Preferred_Language: string;
  Preferred_Currency: string;
  Summary_Email_Enabled: boolean;
}

export interface UserEditPreferences {
  Alert_Ready_Order: boolean;
  Date_Pattern: DatePatternEnum;
  Thousand_Separator: NumberSeparatorEnum;
  Decimal_Separator: NumberSeparatorEnum;
}

export interface UserAuditView {
  First_Name: string;
  Last_Name: string;
  Email: string;
  Phone: string;
  Mobile: string;
  Blocked: boolean;
  Preferred_Language: string;
  Preferred_Currency: string;
  GDPR_Acceptance_Date: string;
  Date_Pattern: DatePatternEnum;
  Thousand_Separator: NumberSeparatorEnum;
  Decimal_Separator: NumberSeparatorEnum;
  Alert_Ready_Order: boolean;
}

export class User implements UserCreate, UserView, UserEdit, UserAuditView, UserEditSelf, UserEditPreferences,CreateExternalUser {
  Id: string;
  Email: string;
  First_Name: string;
  Last_Name: string;
  Phone: string;
  Mobile: string;
  Role: RoleEnum;
  Entities?: UserEntity[] = [];
  Preferred_Language: string;
  Preferred_Currency: string;
  GDPR_Accepted: boolean;
  Blocked: boolean;
  PermissionSet: PermissionEnum[];
  GDPR_Acceptance_Date: string;
  Alert_Ready_Order: boolean;
  Date_Pattern: DatePatternEnum;
  Notifications: UserNotificationView[];
  Thousand_Separator: NumberSeparatorEnum;
  Decimal_Separator: NumberSeparatorEnum;
  Summary_Email_Enabled: boolean;
  Captcha: string;
}

export interface CreateExternalUser extends ReCaptcha {
  Email: string;
  First_Name: string;
  Last_Name: string;
  Phone: string;
  Mobile: string;
  Preferred_Language: string;
  Preferred_Currency: string;
  GDPR_Accepted: boolean;
}
